import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface ProductInformationStateType {
    readonly productSelectQty?: number;
    readonly productCopyPaste?: string;
    readonly isLoadingMultipleProducts?: boolean;
    readonly isAddedMultipleProductsCompleted?: boolean;
}

export type CustomProductInformationState = Readonly<ProductInformationStateType>;

export const initialProductInformationState: CustomProductInformationState = {
    isLoadingMultipleProducts: false,
    isAddedMultipleProductsCompleted: false,
};

export const customProductInformationReducer = createTypedReducer(initialProductInformationState, {
    "Custom/ProductInformation/SetProductSelectQty": (
        draft: Draft<CustomProductInformationState>,
        { qty: productSelectQty }: { qty: number },
    ) => ({
        ...draft,
        productSelectQty,
    }),
    "Custom/ProductInformation/SetProductCopyPaste": (
        draft: Draft<CustomProductInformationState>,
        { info: productCopyPaste }: { info: string },
    ) => ({
        ...draft,
        productCopyPaste,
    }),
    "Custom/ProductInformation/ClearProductSelect": (draft: Draft<CustomProductInformationState>) => ({
        ...draft,
        productSelectQty: undefined,
        productCopyPaste: undefined,
    }),
    "Custom/ProductInformation/LoadingMultipleProducts": (
        draft: Draft<CustomProductInformationState>,
        { isLoading: isLoadingMultipleProducts }: { isLoading: boolean },
    ) => ({
        ...draft,
        isLoadingMultipleProducts,
    }),

    "Custom/ProductInformation/AddMultipleProductsCompleted": (
        draft: Draft<CustomProductInformationState>,
        { addedMultipleProducts: isAddedMultipleProductsCompleted }: { addedMultipleProducts: boolean },
    ) => ({
        ...draft,
        isAddedMultipleProductsCompleted,
    }),
});
